import { AdminData } from "./admin.token.service";

class PermissionCheckerService {
    /**
     * Checks if the admin has a specific permission based on the actionId.
     * @param adminData The administrator data containing roles and permissions.
     * @param actionId The ID of the action to check.
     * @returns true if the permission is found, false otherwise.
     */
    checkPermission(adminData: AdminData | null, moduleName : string, actionName : string): boolean {
        if (!adminData || !adminData.Roles || moduleName === "" || actionName === "") {
            return false;
        }

        moduleName = moduleName.toUpperCase();
        actionName = actionName.toUpperCase();

        // Iterate through all roles of the admin
        for (const role of adminData.Roles) {
            if (role.IsSuperAdmin || (role as any).isSuperAdmin) {
                return true;
            }

            if (role.Permissions) {
                // Find if any permission matches the actionId
                const hasPermission = role.Permissions.some(
                    (p) => p.Action.toUpperCase() === actionName && p.ModuleName.toUpperCase() === moduleName
                );
                if (hasPermission) {
                    return true;
                }
            }
        }

        return false;
    }
}

export const permissionCheckerService = new PermissionCheckerService();
